import { render, staticRenderFns } from "./render.vue?vue&type=template&id=12e70a80"
import script from "./render.vue?vue&type=script&lang=js"
export * from "./render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports